"use client";

import { ReactNode } from "react";
import { useSessionErrorHandler } from "@/lib/hooks/useSessionErrorHandler";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { suppressAuthConsoleNoise } from "@/lib/errors/suppressAuthConsoleNoise";

// supabase-js 内部の一過性 auth エラーが PostHog $exception 化されるのを防ぐ。
// 最初の Supabase 呼び出しより前に効かせたいのでモジュール評価時に適用する。
suppressAuthConsoleNoise();

interface AuthProviderProps {
  children: ReactNode;
}

// アプリ全体で共有するキャッシュクライアント
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5分はキャッシュを使い回す（ページ間遷移で再フェッチを抑制）
      gcTime: 10 * 60 * 1000, // 10分はメモリに保持
      retry: 1,
      refetchOnWindowFocus: false, // タブ切り替えで余計な再フェッチを防止
    },
  },
});

function SessionErrorHandler({ children }: { children: ReactNode }) {
  useSessionErrorHandler();
  return <>{children}</>;
}

export default function AuthProvider({ children }: AuthProviderProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionErrorHandler>{children}</SessionErrorHandler>
    </QueryClientProvider>
  );
}
